import packingRequest from '../request/packing'

const apiRequest = packingRequest()

export const getListBrands = async (payload) => {
    const {data} = await apiRequest({
        url: `/order/get-list-brand`,
        method: 'POST',
        data: payload
    })

    return data
}

export const createBrandNew = (payload) => {
    return apiRequest({
        url: '/order/brand',
        method: 'POST',
        data: payload
    })
}

export const updateBrandName = async (id, payload) => {
    const {data} = await apiRequest({
        url: `/order/brand/${id}`,
        method: 'PUT',
        data: payload
    })
    return data
}

export const createTagBrand = (data) => {
    return apiRequest({
        url: `/order/create-brand-tag`,
        method: 'POST',
        data,
    })
}

export const editTagBrand = (_id, data) => {
    return apiRequest({
        url: `/order/brand-tag/${_id}`,
        method: 'PUT',
        data,
    })
}

export const getListTagBrand = (data) => {
    return apiRequest({
        url: `/order/brand-tag/search`,
        method: 'POST',
        data,
    })
}

export const getTagBrandDetail = (id) => {
    return apiRequest({
        url: `/order/brand-tag/${id}`,
        method: 'GET',
    })
}

export const createBrandsRule = (data) => {
    return apiRequest({
        url: `packing/brand-tag/rule`,
        method: 'POST',
        data: data,
    })
}
export const updateBrandsRule = (id,data) => {
    return apiRequest({
        url: `packing/brand-tag/rule/${id}`,
        method: 'PUT',
        data: data,
    })
}
export const brandsRuleDetails = (id) => {
    return apiRequest({
        url: `packing/brand-tag/rule/${id}`,
        method: 'GET',
    })
}

export const getListBrandRule = (data) => {
    return apiRequest({
        url: `/order/get-list-brand-rule`,
        method: 'POST',
        data
    })
}

export const changeStatusBrandRulePage = (ruleId, data) => {
    return apiRequest({
        url : `packing/brand-tag/rule/${ruleId}`,
        method : 'PUT',
        data
    })
}

export const getQuantityWarning = () => {
    return apiRequest({
        url : `order/brand-tag/count/quantity`,
        method : 'GET',
    })
}

export const getExportTagBrands = (data) => {
    return apiRequest({
        url: `/order/brand-tag/export-csv`,
        method: 'POST',
        data: data,
    })
}

export const getExportBrands = (data) => {
    return apiRequest({
        url: `/order/brand/export-csv`,
        method: 'POST',
        data: data,
    })
}

export const getExportBrandsRule = (data) => {
    return apiRequest({
        url: `/order/brand-rule/export-csv`,
        method: 'POST',
        data: data,
    })
}

export const getQuantityComboNotCompete = (data) => {
    return apiRequest({
        url: `/order/combo/count/not-compete`,
        method: 'GET',
    })
}